import BrowseRecords from './BrowseRecords';

export default BrowseRecords;
